import FaqsList from './FaqsList'

export default FaqsList
// eslint-disable-next-line import/export
export * from './FaqsList'
